import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';
import { IconComponent } from '../../shared/components/icon/icon.component';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
})
export class UnauthorizedComponent {
  // No session here by definition — send the user straight to the login page.
  readonly mainPortalUrl = environment.PORTAL_LOGIN_URL;
}
